export default function(t,o){if(void 0===o&&(o=0),"function"==typeof t)return window.setTimeout(cb,o)}
